import { ContactPerson } from 'react-webapp/src/features/contacts/types/contactPerson'

import { CustomerForm } from '../../../../../types/customerForm'
import { isContactPersonMainFieldsFilled } from '../../../utils/contactPersons/contactPersonValidation'
import { addPrimaryContactFromMainFields } from './addPrimaryContactFromMainFields'
import { appendNewPrimaryContact } from './appendNewPrimaryContact'
import { clearPrimaryFlagFromContactPersons } from './clearPrimaryFlagFromContactPersons'
import { updateAndReassignPrimaryContact } from './updateAndReassignPrimaryContact'
import { updateEditedContactToPrimary } from './updateEditedContactToPrimary'

interface UpdateContactPersonsWithPrimaryContactProps {
  contactPersons: ContactPerson[]
  editedIndex: number
  newPrimaryContactData: ContactPerson
  values: CustomerForm
}

export const updateContactPersonsWithPrimaryContact = ({
  contactPersons,
  editedIndex,
  newPrimaryContactData,
  values,
}: UpdateContactPersonsWithPrimaryContactProps) => {
  const { email, firstName, lastName } = values
  const currentPrimaryContactIndex = contactPersons.findIndex((contact) => contact.isPrimary)
  const hasPrimaryContact = currentPrimaryContactIndex !== -1
  const isEditingPrimaryContact = currentPrimaryContactIndex === editedIndex

  const contactsWithoutPrimary = clearPrimaryFlagFromContactPersons(contactPersons)
  const currentPrimaryContactHasData = isContactPersonMainFieldsFilled(email, firstName, lastName)

  const shouldCreatePrimaryContactFromMainFields = !hasPrimaryContact && currentPrimaryContactHasData

  if (hasPrimaryContact && !isEditingPrimaryContact) {
    return updateAndReassignPrimaryContact({
      contacts: contactsWithoutPrimary,
      currentPrimaryContactIndex,
      editedIndex,
      email,
      firstName,
      lastName,
      newPrimaryContactData,
    })
  }

  if (shouldCreatePrimaryContactFromMainFields) {
    // When there is no primary contact yet, but user provided main fields data,
    // and we update the edited contact and create a new primary contact entry
    const updatedContacts = addPrimaryContactFromMainFields({
      contacts: contactsWithoutPrimary,
      editedIndex,
      email,
      firstName,
      lastName,
    })

    return appendNewPrimaryContact(updatedContacts, newPrimaryContactData)
  }

  return updateEditedContactToPrimary({
    contacts: contactsWithoutPrimary,
    editedIndex,
    newPrimaryContactData,
  })
}
